import React, { ReactNode } from 'react'
import './copy-button.css'

interface CopyButtonProps {
  type?: 'submit' | 'reset' | 'button' | undefined
  onClick: () => void
  children: ReactNode | ReactNode[]
}

export const CopyButton: React.FC<CopyButtonProps> = ({
  type,
  onClick,
  children,
}) => {
  return (
    <button
      className="copy-button"
      type={type}
      onClick={onClick}
      aria-label="Copy"
    >
      {children}
    </button>
  )
}
